import { mapGetters, mapActions, mapMutations } from 'vuex'
import {
  ManagerUser,
  EnableUser
} from '@/components'

import {
  UserTypes
} from '@/mixins'

export default {
  mixins: [
    UserTypes
  ],
  components: {
    ManagerUser,
    EnableUser
  },
  data () {
    return {
      isLoadingAllUsers: false,
      managerUser: false,
      managerEnableUser: false,
      search: '',
      selectedFilter: 'name',
      headers: [
        { text: 'Ações', align: 'center', sortable: false },
        { text: 'Bloqueado', value: 'enabled', align: 'center' },
        { text: 'Nome', value: 'name', align: 'left' },
        { text: 'E-mail', value: 'email', align: 'left' },
        { text: 'Tipo', value: 'idUserType', align: 'left' }
      ],
      listActions: [
        {
          name: 'Editar',
          value: 'edit',
          action: (item) => this.managerUserModals('edit', item)
        },
        {
          name: 'Bloquear',
          value: 'enable',
          action: (item) => this.managerUserModals('enable', item)
        }
      ],
      filterStatus: null,
      statuses: [
        { text: 'Não', value: true },
        { text: 'Sim', value: false },
        { text: 'Todos', value: null }
      ],
      filterUserType: null,
      userTypes: [
        { text: 'Suporte', value: 1 },
        { text: 'Vendedor', value: 2 },
        { text: 'Operador', value: 3 },
        { text: 'Implantador', value: 4 },
        { text: 'Operador Guide', value: 5 },
        { text: 'Financeiro', value: 6 },
        { text: 'Todos', value: null }
      ]
    }
  },

  computed: {
    ...mapGetters([
      'getterAccount',
      'getterUsers'
    ]),
    filteredUsers () {
      let result = ''

      if (this.search !== '') {
        result = this.getterUsers.filter((item) => {
          if (item[this.selectedFilter] !== null) {
            return item[this.selectedFilter].toLowerCase().includes(this.search.toLowerCase())
          }

          return item[this.selectedFilter]
        })
      } else {
        result = this.getterUsers
      }

      if (this.filterStatus !== null) {
        result = result.filter((item) => item.enabled === this.filterStatus)
      }

      if (this.filterUserType !== null) {
        result = result.filter((item) => item.idUserType === this.filterUserType)
      }

      return result
    },
    filteredHeader () {
      return this.headers.filter((item) => item.value === 'name' || item.value === 'email')
    }
  },
  mounted () {
    this.getAllUsers(this.getterAccount)
  },
  methods: {
    ...mapActions([
      'actionGetAllUsers'
    ]),
    ...mapMutations([
      'SELECT_USER'
    ]),
    returnTrueValueName (item) {
      let result = ''

      if (item.enabled) {
        result = 'Bloquear'
      } else {
        result = 'Desbloquear'
      }

      return result
    },
    managerUserModals (type, user) {
      switch (type) {
        case 'edit':
          this.managerUser = true
          break
        case 'enable':
          this.managerEnableUser = true
          break
        default:
          this.managerUser = true
      }

      this.SELECT_USER(user)
    },
    getAllUsers (client) {
      this.isLoadingAllUsers = true

      this.actionGetAllUsers(client.idClient)
        .then(() => {
          this.isLoadingAllUsers = false
        })
        .catch(() => {
          this.isLoadingAllUsers = false
        })
    }
  }
}
